/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import EnglishAgent from '../components/englishAgent';

function ProductLinkedin() {
  return (
    <div className="main">
      <Header />
      <EnglishAgent />
      <Footer />
    </div>
  );
}

export default ProductLinkedin;
